import { render, staticRenderFns } from "./QuizContent.vue?vue&type=template&id=723ebfae&"
import script from "./QuizContent.vue?vue&type=script&lang=js&"
export * from "./QuizContent.vue?vue&type=script&lang=js&"
import style0 from "./QuizContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports